import { Card, Skeleton } from "antd";
import Link from "next/link";
import { useMemo } from "react";

import Images from "@/components/Images";
import { useListReward } from "@/hooks/useRewards";
import { PAGE_URL } from "@/utils/constants";
import { formatNumber } from "@/utils/helper";

import EmptyRewardsImg from "@/assets/empty/empty-rewards.png";
import Image from "next/image";

interface IRewardsWidget {}

export default function RewardsWidget({}: IRewardsWidget) {
  const { data, isFetching } = useListReward({ purpose: "LIST" });

  const dataChoosen: any = useMemo(() => {
    if (data) {
      const index = Math.floor(Math.random() * data?.length);
      return data[index];
    }
    return {};
  }, [data]);

  return (
    <Card
      className="bg-card w-full"
      title={
        <div className="flex items-center justify-between">
          <p className="font-bold text-white">Rewards</p>
          {data && data?.length && (
            <Link href={PAGE_URL.rewards}>
              <span className="text-yellow text-sm">View More Rewards</span>
            </Link>
          )}
        </div>
      }
    >
      <div>
        {isFetching ? (
          <div className="h-[300px] flex flex-col gap-3">
            <Skeleton.Input block active size="large" style={{ height: 250 }} />
            <Skeleton.Input block active style={{ height: 50 }} />
          </div>
        ) : (data && data.length > 0) ? (
          <div className="flex flex-col gap-3">
            <div className="overflow-hidden w-full h-full max-h-[400px] lg:max-h-[600px] bg-black">
              {/* <div className="w-[50%] mx-auto h-[600px]" /> */}
              <Images
                alt={dataChoosen?.title}
                // src={dataChoosen?.imageUrl}
                src={dataChoosen?.imageUrl}
                width={400}
                height={300}
                className="w-[50%] mx-auto h-full object-cover"
              />
            </div>
            <div className="mt-4">
              <div dangerouslySetInnerHTML={{ __html: dataChoosen?.title }} />
              <p className="text-grey text-sm">
                {formatNumber(dataChoosen?.points)} Points
              </p>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center h-[300px]">
            <div className="flex flex-col items-center gap-3">
              <Image
                alt={"Empty Rewards"}
                src={EmptyRewardsImg}
                height={64}
                width={64}
                className="lg:w-[20%] mx-auto"
              />
              <p className="text-center mx-auto text-white text-sm lg:text-base font-body">
                Start earning points now so you can redeem exiciting rewards
                when they are available!
              </p>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}
